import type { Bracket } from './protocol';

/** What talking to an NPC offers: a ranked queue, practice, or picking a class. */
export type NpcRole = Bracket | 'practice' | 'class';

export interface HubNpc {
  id: string;
  name: string;
  title: string;
  role: NpcRole;
  /** Character model, by path under `assets/models/`. */
  model: string;
  /** Tile it stands on in `assets/hub.json`. */
  x: number;
  z: number;
  yaw: number;
}

/** How close (between capsule edges) a player has to be to talk to an NPC. */
export const NPC_RANGE = 5;

/** Hub emotes and the character clip each plays; ones with `seconds` end on their own, the rest when the player moves. */
export const EMOTES = {
  sit: { clip: 'sit' },
  kneel: { clip: 'crouch' },
  yes: { clip: 'emote-yes', seconds: 2 },
  no: { clip: 'emote-no', seconds: 2 },
} satisfies Record<string, { clip: string; seconds?: number }>;
export type Emote = keyof typeof EMOTES;
export const EMOTE_IDS = Object.keys(EMOTES) as Emote[];

export const HUB_NPCS: HubNpc[] = [
  {
    id: 'npc-1v1',
    name: 'Grimsby',
    title: '1v1 Battlemaster',
    role: '1v1',
    model: 'graveyard/character-skeleton',
    x: -3,
    z: -5,
    yaw: Math.PI,
  },
  {
    id: 'npc-2v2',
    name: 'Morwen',
    title: '2v2 Battlemaster',
    role: '2v2',
    model: 'graveyard/character-zombie',
    x: 0,
    z: -5,
    yaw: Math.PI,
  },
  {
    id: 'npc-3v3',
    name: 'Captain Hale',
    title: '3v3 Battlemaster',
    role: '3v3',
    model: 'character-soldier',
    x: 3,
    z: -5,
    yaw: Math.PI,
  },
  {
    id: 'npc-practice',
    name: 'Brakka',
    title: 'Practice Master',
    role: 'practice',
    model: 'dungeon/character-orc',
    x: -5,
    z: 0,
    yaw: -Math.PI / 2,
  },
  {
    id: 'npc-class',
    name: 'Elder Ivo',
    title: 'Class Trainer',
    role: 'class',
    model: 'graveyard/character-keeper',
    x: 5,
    z: 0,
    yaw: Math.PI / 2,
  },
];
